<ion-accordion-group>
  <ion-accordion value="conditions">
    <ion-item
      slot="header"
      color="white"
    >
      <ion-label>
        Condiciones generales para el
        <strong>pronto pago</strong>
        a transportistas
      </ion-label>
    </ion-item>
    <div
      class="fs-xs"
      slot="content"
    >
      <ol>
        <li>
          Mediante la acción de pulsar el botón de solicitud de pronto pago, el transportista solicita a okcargo
          anticipar el cobro del servicio de transporte realizado, aplicándose un descuento del 3% sobre el importe de
          dicho de servicio con un mínimo de quince euros (15,00 €).
        </li>
        <li>
          Para que okcargo apruebe la solicitud será necesario que la empresa transportista haya proporcionado, a través
          de la app para móviles para iOS o Android o de la aplicación web alojada en https://carriers.okcargo.io/, los
          siguientes documentos:
          <ul>
            <li>
              Certificado acreditativo de estar al corriente de las obligaciones fiscales emitido por la administración
              tributaria del territorio donde esté ubicada la sede de la empresa (Agencia Tributaria, Hacienda
              Foral,...) y en vigor.
            </li>
            <li>
              Certificado acreditativo de estar al corriente de pago con la Tesorería General de la Seguridad Social (u
              organismo equivalente del territorio donde esté ubicada la sede de la empresa), emitido dentro de los 30
              días anteriores a la solicitud.
            </li>
            <li>
              Certificado de titularidad de la cuenta bancaria en la que se abonará la factura, emitido por la entidad
              bancaria.
            </li>
          </ul>
        </li>
        <li>
          Además, en el caso de empresas sin sede en España, okcargo podrá solicitar documentación adicional
          acreditativa de que la actividad de la empresa solicitante se ajusta a la legalidad y usos del sector.
        </li>
        <li>
          La empresa de transporte también deberá haber aportado, a través de la app para móviles para iOS o Android o
          de la aplicación web, una copia digitalizada de los albaranes de la carga transportada en el servicio por el
          que se solicita el pronto pago.
        </li>
        <li>
          okcargo podrá denegar la solicitud de pronto pago en el caso de que la documentación aportada no sea válida o
          esté incompleta, así como en los casos en los casos en los que existan reservas en la descarga por parte del
          cargador, expedidor o destinatario. La empresa transportista podrá consultar el estado de cada solicitud de
          pronto pago en los detalles del servicio por el que ha solicitado esta forma de cobro.
        </li>
        <li>
          Una vez autorizada la solicitud por okcargo se procederá a emitir la factura correspondiente a nombre de la
          empresa transportista (autofactura) y se ordenará el pago por transferencia bancaria.
        </li>
      </ol>
    </div>
  </ion-accordion>
</ion-accordion-group>
